import axios from "axios";

// const baseURL =
//   process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
// const baseURL = "https://event-management-backend-sandy.vercel.app/api";

const baseURL = "https://eventstory4u.com/api";
const api = axios.create({ baseURL, timeout: 15000 });

// Attach admin token if present (set after admin login).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("es_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
